export default __webpack_public_path__ + "static/mobile-big-1x-472ed1b218674cca487d96f198728f2b.jpeg";